// Groups saved appearance rows into one result per keyword + location + round
// (+ device, for scans that ran mobile and desktop; old scans have none).
export function appearancesToResults(appearances) {
  const map = {};
  appearances.forEach(a => {
    const key = `${a.keyword}|${a.location}|${a.round}` + (a.device ? `|${a.device}` : "");
    if (!map[key]) map[key] = { id: key, keyword: a.keyword, location: a.location, round: a.round, device: a.device || null, timestamp: new Date(a.created_at), paid: [], organic: [], localPack: [], shopping: [], lsa: [] };
    const item = { ...(a.raw_data || {}), _domain: a.business_domain || null, _name: a.raw_name || null };
    if (a.channel === "ppc") map[key].paid.push(item);
    else if (a.channel === "gbp") map[key].localPack.push(item);
    else if (a.channel === "seo") map[key].organic.push(item);
    else if (a.channel === "shopping") map[key].shopping.push(item);
    else if (a.channel === "lsa") map[key].lsa.push(item);
  });
  return Object.values(map);
}

// keyword / location: one value, or a list of values. "all" or an empty list
// means no filter.
export function filterResults(results, keyword, location, device = "all") {
  const allows = (wanted, value) =>
    wanted === "all" || (Array.isArray(wanted) ? wanted.length === 0 || wanted.includes(value) : value === wanted);
  return results.filter(r => {
    if (!allows(keyword, r.keyword)) return false;
    if (!allows(location, r.location)) return false;
    if (device !== "all" && r.device !== device) return false;
    return true;
  });
}

// "mobile" / "desktop" - empty for old jobs, which didn't record a device.
export function uniqueDevices(results) {
  return [...new Set(results.map(r => r.device).filter(Boolean))].sort();
}

export function uniqueKeywords(results) {
  return [...new Set(results.map(r => r.keyword))];
}

export function uniqueLocations(results) {
  return [...new Set(results.map(r => r.location))];
}
